import React from 'react';
import PropTypes from 'prop-types';
import { CMSStore } from 'four-nets/cms/cms';

import LoadingProgress from 'lib/react-router/loading-progress';
import FetchData from 'lib/fetch-data/fetch-data';
import ErrorPage from 'four-nets/errors/error-page';

import CMSItemView, { CMSItemViewModel } from './cms-view';

class CMSLoader extends React.PureComponent {
    static contextTypes = {
        app: PropTypes.object,
        api: PropTypes.object,
    };

    transform = data => {
        const { api } = this.context;
        const cmsStore = new CMSStore({
            api,
        });

        if (data?.cmsItem) {
            const cmsItem = cmsStore.processJSON({ json: data.cmsItem });

            return {
                cmsItem,
                cmsItemViewModel: new CMSItemViewModel(cmsItem),
            };
        }

        return {
            cmsItem: null,
            cmsItemViewModel: null,
        };
    };

    fetch = (setData, { cmsKey }) => {
        const { api } = this.context;
        const cmsStore = new CMSStore({
            api,
        });

        return cmsStore.load(cmsKey).then(cmsItem => {
            if (cmsItem) {
                const cmsItemViewModel = new CMSItemViewModel(cmsItem);

                setData({
                    cmsItemViewModel,
                    cmsItem,
                });
            } else {
                setData({
                    cmsItemViewModel: null,
                    cmsItem: null,
                });
            }
        });
    };

    renderFetch = ({ loading, data, error }) => {
        return this.props.render ? (
            data && data.cmsItem ? (
                this.props.render(data.cmsItem)
            ) : null
        ) : (
            <LoadingProgress loading={loading}>
                <ErrorPage error={error}>
                    {data && data.cmsItemViewModel ? <CMSItemView cmsItemViewModel={data.cmsItemViewModel} /> : null}
                </ErrorPage>
            </LoadingProgress>
        );
    };

    render() {
        return (
            <FetchData
                serializerKey={__filename}
                transform={this.transform}
                fetch={this.fetch}
                render={this.renderFetch}
                cmsKey={this.props.cmsKey || this.props.match.params.cmsKey}
            />
        );
    }
}

export default CMSLoader;
